module.exports = __webpack_public_path__ + "fonts/Montserrat-SemiBold.ea9857bc.woff2";